// extracted by mini-css-extract-plugin
module.exports = {"chart":"dashboard_chart__1xs4W","light":"dashboard_light__ZaR4J","dark":"dashboard_dark__a6big"};